import React from "react";
//Router
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import history from "./services/history/BrowserHistory";
import Paths from "./routes/index";
import { SkeletonTheme } from "react-loading-skeleton";
import NavBar from "./components/layout/NavBar";
import Meta from "./components/Meta";
import ScrollToTop from "./components/ScrollToTop";
import MobileFooterNav from "./components/MobileFooterNav";

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID"}>
      <Meta>
        <SkeletonTheme baseColor="#ebebeb" highlightColor="#f5f5f5">
          <BrowserRouter history={history}>
            <ScrollToTop />
            <Paths history={history}>
              <NavBar />
            </Paths>
            <MobileFooterNav />
          </BrowserRouter>
        </SkeletonTheme>
      </Meta>
    </GoogleOAuthProvider>
  );
}

export default App;
